<template lang="pug">
Poptip(placement="top" trigger="hover" transfer @on-popper-show="onPopperShow")
    Button(
        shape="circle"
        icon="md-add"
        size="small"
        :type="isInserting ? 'primary' : 'text'"
        @click="handleButtonClick"
    )
    div(slot="content")
        template(v-if="isInserting")
            p {{ $t('wafrules.insertingHere') }}
            section.segment-insert-poptip-section
                Form(ref="form" :model="form" :rules="formRule" :label-width="80" label-position="left")
                    FormItem(:label="$t('wafrules.literalText')" prop="literalText")
                        Input(
                            v-model="form.literalText"
                            @keydown.enter.native.prevent="handleAddLiteralText"
                            :disabled="disabledLiteralText"
                            @on-focus="disabledVariable = true"
                            @on-blur="disabledVariable = false"
                        )
                            Button(slot="append" @click="handleAddLiteralText" :disabled="!form.literalText || disabledLiteralText") {{ $t('rcmtable.addTagText') }}
                    p.segment-insert-poptip-or {{ $t('wafrules.or') }}
                    FormItem(:label="$t('wafrules.variable')" prop="selectedVariable")
                        Select(
                            v-model="form.selectedVariable"
                            transfer
                            @on-change="handleAddVariable"
                            :disabled="disabledVariable"
                            @on-open-change="handleOpenChange"
                        )
                            Option(v-for="variable in systemVariables" :key="variable.value" :value="variable.value") {{ variable.label }}
        template(v-else)
            p {{ $t('wafrules.clickToInsertHere') }}
</template>

<script>
import enumList from "@/libs/enumList.js";

export default {
    props: {
        targetField: { type: String, default: null },
        insertIndex: { type: Number, default: null },
        isInserting: { type: Boolean, default: false },
        targetFieldRule: {
            type: Object,
            default: () => ({
                literal: [],
                system: [],
            }),
        },
    },
    data() {
        return {
            form: { literalText: "", selectedVariable: "" },
            formRule: {
                literalText: this.targetFieldRule.literal || [],
                selectedVariable: this.targetFieldRule.system || [],
            },
            disabledLiteralText: false,
            systemVariables: enumList.WAF_URI_OR_HEADERS_SYSTEM_VARIABLES.map((item) => ({
                label: this.$t(`wafrules.${item}`),
                value: `$${item}`,
            })),
            disabledVariable: false,
        };
    },
    methods: {
        onPopperShow() {
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetFields());
        },
        handleButtonClick() {
            this.$emit("on-prepare", { insertIndex: this.insertIndex, targetField: this.targetField });
        },
        async handleAddLiteralText() {
            const isValid = await this.$refs.form.validate();
            if (!isValid) return;
            const trimLiteralText = this.form.literalText.trim();
            if (!trimLiteralText) return;
            this.$emit("on-insert", {
                type: "literal",
                value: trimLiteralText,
                targetField: this.targetField,
            });
        },
        handleAddVariable(variable) {
            if (!variable) return;
            this.$nextTick(() => {
                this.$emit("on-insert", {
                    type: "system",
                    value: variable.replace(/^\$/, ""),
                    targetField: this.targetField,
                });
            });
        },
        handleOpenChange(isOpen) {
            if (isOpen) {
                this.disabledLiteralText = true;
            } else {
                this.disabledLiteralText = false;
            }
        },
    },
};
</script>
<style scoped>
.segment-insert-poptip-section {
    padding: 14px;
}
.segment-insert-poptip-or {
    text-align: center;
    margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/SegmentBuilder/InsertButton.vue